var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalStatusLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56.5 46.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.079931 -.47959)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.4862 1.7296h41.368c3.4992 0 6.3162 2.817 6.3162 6.3162v23.368c0 3.4992-2.817 6.3162-6.3162 6.3162h-2.9338v8l-6.8602-8h-31.574c-3.4992 0-6.3162-2.817-6.3162-6.3162v-23.368c0-3.4992 2.817-6.3162 6.3162-6.3162z",
    fill: "none",
    stroke: "#E57B12",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E57B12"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19.5,
    r: 3,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 19.5,
    r: 3,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 19.5,
    r: 3,
    style: {
      paintOrder: "normal"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalStatusLogo);
export default __webpack_public_path__ + "static/media/personal-status-logo.61d7edca684c92faec236a7453ee9fb7.svg";
export { ForwardRef as ReactComponent };